<template>
  <div v-if="loaded">
    <SideResult
      title=""
      :show-buttons="false"
      :metrics="paramData"
      :compact="$vuetify.breakpoint.smAndDown"
      v-if="!form.dlqi.resultado_manual"
      class="py-8"
      style="width: 50%"
    />
    <div
      class="d-flex mt-4 flex-row"
      :class="{
        'flex-column gap-8': $vuetify.breakpoint.smAndDown,
        'gap-12': !$vuetify.breakpoint.smAndDown,
      }"
    >
      <div class="d-flex align-center">
        <v-text-field
          outlined
          dense
          :min="0"
          :max="28"
          type="number"
          v-if="form.dlqi.resultado_manual"
          v-model="form.dlqi.value"
          :rules="[$validation.minValue(0), $validation.maxValue(28)]"
          :disabled="disabled"
          hide-spin-buttons
        />
      </div>
    </div>

    <v-switch
      :disabled="disabled"
      label="Aplicar resultado manualmente"
      v-model="form.dlqi.resultado_manual"
      hide-details
    />

    <div class="mb-4 mt-10">
      <send-attendance-survey survey-type="dlqi" :disabled="disabled"></send-attendance-survey>
    </div>

    <DlqiCalculator
      v-model="paramData"
      ref="calculator"
      v-if="!form.dlqi.resultado_manual && answers"
      :fill-data="answers"
      @input="updateForm"
      @calculate="onCalculate"
      :disabled="disabled"
      class="with-scroll w-full border-r py-8"
    />
  </div>
</template>
<script>
import DlqiCalculator from '@/components/CalculatorContent/DLQI.vue'
import { DLQI_OPTIONS } from '@/components/AttendanceForm/general/constants/dlqiOptions'
import { createNamespacedHelpers } from 'vuex'
import SideResult from '@/components/CalculatorContent/partial/SideResult.vue'
import SendAttendanceSurvey from '@/components/SendAttendanceSurvey.vue'

const {
  mapMutations: newAttendanceFormMutations,
  mapActions: newAttendanceFormActions,
  mapGetters: newAttendanceFormGetters,
} = createNamespacedHelpers('newAttendanceForm')

export default {
  name: 'DlqiParameter',
  components: { SendAttendanceSurvey, SideResult, DlqiCalculator },
  async created() {
    let { questions } = (await this.getParameter('dlqi-parameter')) ?? {}

    if (questions) {
      this.form.profile = questions
    } else {
      const surveyId = this.extraAnswers['survey']?.dlqi?.uuid
      if (surveyId) {
        const survey = await this.$api.getSurveyByUuid(surveyId)
        this.form.profile = []
        const keys = survey.data ? Object.keys(survey.data) : []
        for (const key of keys) {
          if (key === 'done' || key === 'startedAt') {
            continue
          }
          this.form.profile.push({ [key]: { value: survey.data[key].value } })
        }
      }
    }

    // fill default
    this.answers = this.form.profile.reduce((acc, p) => {
      const key = Object.keys(p)[0]
      acc[key] = Object.values(p)[0].value
      return acc
    }, {})

    this.loaded = true
  },
  data() {
    return {
      loaded: false,
      paramData: [],
      answers: undefined,
      form: {
        dlqi: {
          value: null,
        },
        profile: this.buildEmptyProfile(),
        resultado_manual: false,
      },
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...newAttendanceFormGetters(['parameters', 'extraAnswers']),
  },
  methods: {
    ...newAttendanceFormActions(['getParameter']),
    ...newAttendanceFormMutations(['updateParameter']),
    buildEmptyProfile() {
      const profile = []
      for (const option of DLQI_OPTIONS.ADULT) {
        profile.push({ [option.key]: { value: null } })
      }
      return profile
    },
    updateForm(data) {
      const dlqi = data.find((d) => d.name === 'DLQI')
      if (dlqi) {
        this.form.dlqi.value = dlqi.value
      }
    },
    onCalculate(data) {
      this.form.profile = Object.keys(data).map((key) => ({ [key]: { value: data[key] } }))
    },
  },
  watch: {
    form: {
      handler(value) {
        this.updateParameter({
          parameter: 'dlqi-parameter',
          value: { score: value.dlqi.value, questions: value.profile },
        })
      },
      deep: true,
    },
  },
}
</script>
<style scoped></style>
